import GridOutline from "@/components/GridOutline";
import Articles, { ArticlesProps } from "./Articles";
import Badges from "./Badges";
import LoadMore from "./LoadMore";
import { Container, Heading } from "./styles";
import Toolbar from "./Toolbar";
import Total from "./Total";

export type NewsProps = {
  heading: string | null;
  total: number;
  articles: ArticlesProps["articles"];
  loadMore: () => {};
  isReachingEnd?: boolean;
};

const News: React.FC<NewsProps> = (props) => {
  const { heading, articles, total, isReachingEnd, loadMore } = props;

  return (
    <Container>
      {heading && <Heading as="h1">{heading}</Heading>}
      <Toolbar />
      <Badges />
      <Total total={total} />
      <Articles articles={articles}>
        {!!!isReachingEnd && <LoadMore loadMore={loadMore} />}
      </Articles>
      <GridOutline />
    </Container>
  );
};

export default News;
